import { t } from 'ttag'
import { useMemo } from 'react'

import { SLB } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { ProgramTypeBlueIcon } from '@h2/components/icons/programTypeBlue'
import { ProgramTypeYellowIcon } from '@h2/components/icons/programTypeYellow'
import { ProgramTypeGreenIcon } from '@h2/components/icons/programTypeGreen'
import { Card } from '@h2/common/components/card'

import { props } from './props'
import { ContentWrap, OptionBody } from './components'

import { Navigator } from '../highlights/navigator'
import { Back } from '../back'
import { Controls } from '../controls'

const K12Program = ({ inDialog, properties, validate, renderPanel }) => {
  const k12Program = useMemo(() => properties.k12Program, [properties.k12Program])

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={SLB}>
        <Navigator type="educator" />
      </Card.Highlight>
      <Card.Content>
        <ContentWrap>
          <Heading level="2" align="center" mb="12px">
            {t`K12 Program Type`}
          </Heading>
          <Text align="center">{t`Let us know your area of focus:`}</Text>
          <OptionGroup
            gap="15px"
            value={k12Program}
            onClick={value => validate({ k12Program: value })}>
            <Option value="cte">
              <OptionBody>
                <ProgramTypeBlueIcon size="large" />
                <span className="flex">
                  <span>{t`CTE`}</span>
                  <span>{t`I'm a Career Technical Educator.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="special_ed">
              <OptionBody>
                <ProgramTypeGreenIcon size="large" />
                <span className="flex">
                  <span>{t`Special Education`}</span>
                  <span>{t`I focus on Special Education.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="none">
              <OptionBody>
                <ProgramTypeYellowIcon size="large" />
                <span className="flex">
                  <span>{t`Neither`}</span>
                  <span>{t`I'm in general education and/or administration.`}</span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
          <Controls>
            <Back onClick={() => renderPanel('k12Type')} />
          </Controls>
        </ContentWrap>
      </Card.Content>
      <Card.Detour>
        <Back onClick={() => renderPanel('k12Type')} />
      </Card.Detour>
    </Card>
  )
}

K12Program.propTypes = { ...props }

export { K12Program }
